import React from 'react'
import { Modal } from 'react-bootstrap'
import Avatar from '@components/common/Avatar/Avatar.component'
import Button from '@components/common/Button/Button.component'
import { IChatParticipant } from '@dataTypes/chat.type'

type InternalChatMembersModalProps = {
  show: boolean
  onHide: () => void
  recipient: IChatParticipant | null
  members: IChatParticipant[]
  onRemoveMember?: (member: IChatParticipant) => void
}

const InternalChatMembersModal: React.FC<InternalChatMembersModalProps> = ({
  show,
  onHide,
  recipient,
  members,
  onRemoveMember,
}): React.ReactElement => {
  const user = JSON.parse(localStorage.getItem('user') || '{}')
  return (
    <Modal
      show={show}
      onHide={onHide}
      centered
      className="internal-chat-members-modal"
    >
      <Modal.Header closeButton>
        <Modal.Title>Members</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className="internal-chat-members-list">
          {recipient ? (
            <div className="internal-chat-member-item-full">
              <Avatar
                source={
                  recipient.photo ??
                  'https://cdn-icons-png.flaticon.com/128/9131/9131478.png'
                }
                alt={recipient.username}
                width={40}
                height={40}
                style={{ borderRadius: '8px' }}
              />
              <div className="internal-chat-member-item-info-full">
                <div className="internal-chat-member-item-name-full">
                  {recipient.username}
                </div>
                <div className="internal-chat-member-item-role-full">
                  {recipient.user?.role}
                </div>
              </div>
            </div>
          ) : (
            members
              .filter((member) => member.user_id !== user.user_id)
              .map((member) => (
                <div
                  key={member.chat_participant_id}
                  className="internal-chat-member-item-full"
                >
                  {member.photo ? (
                    <Avatar
                      source={member.photo}
                      alt={member.username}
                      width={32}
                      height={32}
                      style={{ borderRadius: '8px' }}
                    />
                  ) : (
                    <span
                      key="no-photo"
                      className="mgc_user_3_fill no-profile-image"
                    />
                  )}
                  <div className="internal-chat-member-item-info-full">
                    <div className="internal-chat-member-item-name-full">
                      {member.username}
                    </div>
                    <div className="internal-chat-member-item-role-full">
                      {member.user?.role}
                    </div>
                  </div>
                  {onRemoveMember && (
                    <Button
                      size="sm"
                      className="button act-button act-button-delete"
                      onClick={() => onRemoveMember(member)}
                      style={{ marginLeft: 'auto' }}
                    >
                      <i className="ti ti-trash"></i>
                    </Button>
                  )}
                </div>
              ))
          )}
        </div>
      </Modal.Body>
      <Modal.Footer>
        <Button size="md" className="button-secondary" onClick={onHide}>
          Close
        </Button>
      </Modal.Footer>
    </Modal>
  )
}

export default InternalChatMembersModal
